module.exports = __webpack_public_path__ + "static/img/mini-bus-red.2d9cb92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-red.svg
// module id = LeaY
// module chunks = 74